"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class XucDndService {
    constructor($log, $rootScope, XucLink, $window) {
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.XucLink = XucLink;
        this.$window = $window;
        this.baseEventName = "DndEvent";
        this.onDndEvent = (phoneEvent) => {
            this.$rootScope.$emit(this.baseEventName, phoneEvent);
        };
        this.subscribe = (scope, callback) => {
            let unregister = this.$rootScope.$on(this.baseEventName, (_, event) => {
                this.$rootScope.$applyAsync(() => {
                    callback(event);
                });
            });
            scope.$on('$destroy', unregister);
        };
        this.init = () => {
            this.$log.info("Starting XucDnd service");
            this.$window.Cti.setHandler(this.$window.Cti.MessageType.DNDEVENT, this.onDndEvent);
            this.XucLink.whenLoggedOut().then(this.unInit);
        };
        this.unInit = () => {
            this.$log.info("Unloading XucDnd service");
            this.XucLink.whenLogged().then(this.init);
        };
        this.subscribeToDndEvent = (scope, callback) => {
            this.subscribe(scope, callback);
        };
        this.$log.debug('XucDndService service initialization');
        this.XucLink.whenLogged().then(this.init);
    }
}
exports.default = XucDndService;
XucDndService.$inject = ["$log", "$rootScope", "XucLink", "$window"];
